export enum FilterDocumentStatusesEnum{
    Pending='pending',
    Accepted='accepted',
    Lost='lost',
    Draft='draft'
}